import axios from 'axios';

import { API_BASE_URL } from '@/constants';

export async function searchPetsBySimilarImage(
  file: File,
  options?: { limit?: number; status?: PetStatus; includeSolved?: boolean },
): Promise<SimilarByImageResponse> {
  const formData = new FormData();
  formData.append('image', file);

  const response = await axios.post<SimilarByImageResponse>(
    `${API_BASE_URL}/pets/similar-by-image/`,
    formData,
    {
      params: {
        limit: options?.limit ?? 12,
        ...(options?.status ? { status: options.status } : {}),
        ...(options?.includeSolved ? { include_solved: 'true' } : {}),
      },
    },
  );

  return response.data;
}
